module.exports = __webpack_public_path__ + "ccd05187fb9fcb5f74fda7b7453e0b53.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/gallery/loose-skin/loose-skin-1b.jpg
 ** module id = 438
 ** module chunks = 0
 **/